import { WixOOISDKAdapter } from '@wix/bookings-adapter-ooi-wix-sdk';

export function renderNoIndexMetaTag(wixSdkAdapter: WixOOISDKAdapter) {
  wixSdkAdapter.setRobotsNoIndex();
}
